import { ColumnDef } from "@tanstack/react-table";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/Datatable";
import NACell from "../Reusable/Datatable/NACell";
import Filter from "./Filter";
import { tw } from "@careinfo/tailwind";
import Button from "../Reusable/Button";
import { useDownload } from "@careinfo/layout";
import moment from "moment";
import { toast } from "react-toastify";

const SalesRegister = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      ids: searchParams.get("ids") || "",
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
      created: searchParams.get("created") || "",
    },
  });

  const formValues = useWatch({ control });
  const handleIndividualSelect = (value: string) => {
    const clonedParams = new URLSearchParams(searchParams);
    const selectedItems = clonedParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems.length) {
      clonedParams.set("selectedItems", value);
      setSearchParams(clonedParams);
      return;
    }
    const index = selectedItems.findIndex((item) => item === value);
    if (index > -1) selectedItems.splice(index, 1);
    else selectedItems.push(value);

    if (selectedItems.length)
      clonedParams.set("selectedItems", selectedItems.join(","));
    else clonedParams.delete("selectedItems");
    clonedParams.set("selectAllItems", "0");
    setSearchParams(clonedParams);
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    return selectedItems ? selectedItems.includes(value) : false;
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const clonedParams = new URLSearchParams(searchParams);
    if (clonedParams.get("selectAllItems") === "1") {
      clonedParams.set("selectAllItems", "0");
      clonedParams.delete("selectedItems");
    } else {
      const selectedItems = tableData?.map((item: any) => item.id).join(",");
      clonedParams.set("selectAllItems", "1");
      clonedParams.set("selectedItems", selectedItems);
    }
    setSearchParams(clonedParams);
  };

  const columns: ColumnDef<any, any>[] = [
    {
      id: "select",
      header: ({ table }: any) => (
        <input
          type="checkbox"
          checked={checkedAllItems}
          onChange={() => handleSelectAll(table)}
          className={tw`cursor-pointer`}
        />
      ),
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      accessorKey: "miti",
      header: "Miti",
      cell: ({ row, getValue }: any) => (
        <p className={tw`whitespace-nowrap`}>{getValue()}</p>
      ),
    },
    {
      accessorKey: "seq_no",
      header: "Bill No.",
      cell: NACell,
    },
    {
      accessorKey: "party.full_name",
      header: "Customer Name",
      cell: NACell,
    },
    {
      accessorKey: "party.vat_pan",
      header: "PAN No.",
      cell: NACell,
    },
    {
      accessorKey: "total.total_amount",
      header: "Total Sales Amt.",
      cell: NACell,
    },
    {
      accessorKey: "total.non_taxable_amount",
      header: "Exempted Amt.",
      cell: NACell,
    },
    {
      accessorKey: "total.taxable_amount",
      header: "Taxable Amt.",
      cell: NACell,
    },
    {
      accessorKey: "total.tax_amount",
      header: "VAT",
      cell: NACell,
    },
  ];

  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([_, value]) =>
              value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );
      const selectedIds = searchParams.get("selectedItems")?.split(",");
      if (!selectedIds?.length) {
        toast.error("Please select at least one first...");
        return;
      }
      const payload = {
        ...cleanedParams,
        ids: selectedIds,
      };
      await download(
        `${APIS.BILL}sales-excel-file/`,
        `sales-return-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`,
        `${payload.ids}`
      );
      searchParams.delete("selectedItems");
      setSearchParams(searchParams);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-4`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <DataTable
        columns={columns}
        queryKey={"sales"}
        url={APIS.SALES_PURCHASE}
        params={{
          ...formValues,
          type: "Sales Invoice",
          is_draft: false,
        }}
        customSearch={true}
        tableName="sales-register"
      />
    </>
  );
};

export default SalesRegister;

